import { faHouse } from '@fortawesome/pro-light-svg-icons';
import { Fragment } from 'react';

import { Icon } from './icon.component';

import { Skeleton } from '@/components/ui/skeleton.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import {
  BreadcrumbBase,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb-base.component';

interface BreadcrumbSkeletonProps {
  depth: number;
}

export const BreadcrumbSkeleton: React.FC<BreadcrumbSkeletonProps> = ({ depth }) => {
  return (
    <BreadcrumbBase className="h-10 bg-gray-200/40 border-spacing-2">
      <ContentContainer className="flex items-center h-full">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Icon icon={faHouse} size="lg" className="text-green-500" />
          </BreadcrumbItem>
          {[...Array(depth)].map((_, index) => (
            <Fragment key={index}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <Skeleton className="h-5" style={{ width: `${5 + index}rem` }} />
              </BreadcrumbItem>
            </Fragment>
          ))}
        </BreadcrumbList>
      </ContentContainer>
    </BreadcrumbBase>
  );
};
